/* edg-variant-explorer.js — "Explore todas as cores disponíveis"
   Seção complementar abaixo da grade de coleção/busca com um card por
   variação elegível dos produtos pai atualmente renderizados.
   Fonte de dados: <script data-edg-family-data> embutido em cada
   .product-card por snippets/product-card.liquid (a grade é a fonte de
   verdade — filtros AJAX, ordenação, paginação e infinite scroll mantêm
   a seção em sincronia por construção). Carregado apenas quando a seção
   sections/edg-variant-explorer.liquid renderiza. */
(() => {
  "use strict";
  if (window.__edgVariantExplorer__) return;
  window.__edgVariantExplorer__ = true;

  const GRID_ID = "ProductGridContainer";
  const WIDTHS = [180, 360, 540, 720];
  const FILTER_PARAM = "filter.v.m.custom.color_family";

  const resized = (base, width) => {
    try {
      const url = new URL(base, location.origin);
      url.searchParams.set("width", String(width));
      return url.href;
    } catch (_) {
      return base;
    }
  };

  const variantUrl = (base, id) => {
    try {
      const url = new URL(base, location.origin);
      url.searchParams.set("variant", id);
      return url.pathname + url.search;
    } catch (_) {
      return base;
    }
  };

  /* Família ativa: reusa o detector do edg-family-cards (mesma página);
     fallback: só o parâmetro de filtro (sem mapa de termos). */
  const activeFamily = () => {
    if (typeof window.__edgActiveFamily__ === "function") {
      return window.__edgActiveFamily__();
    }
    const filters = new URLSearchParams(location.search).getAll(FILTER_PARAM);
    return filters.length ? filters[0] : null;
  };

  const track = (name, detail) => {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail }));
    } catch (_) {}
  };

  /* Lê os dados embutidos nos cards da grade. */
  const collectParents = () => {
    const grid = document.getElementById(GRID_ID);
    if (!grid) return [];
    const parents = [];
    grid.querySelectorAll(".product-card").forEach((card) => {
      const dataEl = card.querySelector("script[data-edg-family-data]");
      if (!dataEl) return;
      let parsed;
      try {
        parsed = JSON.parse(dataEl.textContent);
      } catch (_) {
        return;
      }
      if (Array.isArray(parsed) || !parsed || !parsed.p || !Array.isArray(parsed.v)) return;
      parents.push({ product: parsed.p, variants: parsed.v, card });
    });
    return parents;
  };

  const setup = (root) => {
    if (root.dataset.edgVxReady) return;
    root.dataset.edgVxReady = "1";

    let cfg;
    try {
      cfg = JSON.parse(root.querySelector("script[data-edg-vx-settings]").textContent);
    } catch (_) {
      return;
    }

    const list = root.querySelector("[data-edg-vx-list]");
    const pillsWrap = root.querySelector("[data-edg-vx-pills]");
    const pillsList = pillsWrap && pillsWrap.querySelector("ul");
    const counter = root.querySelector("[data-edg-vx-counter]");
    const moreBtn = root.querySelector("[data-edg-vx-more]");
    const moreLabel = moreBtn && moreBtn.querySelector("[data-edg-vx-more-label]");
    const allShown = root.querySelector("[data-edg-vx-all]");
    const cardTpl = root.querySelector("template[data-edg-vx-template-card]");
    const pillTpl = root.querySelector("template[data-edg-vx-template-pill]");
    if (!list || !cardTpl) return;

    const state = { items: [], filter: null, shown: cfg.initial, sig: null, viewed: false };

    /* ── Elegibilidade (contrato: variantes comercialmente disponíveis,
       com imagem própria quando exigido, restritas à família ativa) ── */
    const computeItems = () => {
      const parents = collectParents();
      const family = cfg.restrictFamily ? activeFamily() : null;
      const seen = new Set();
      const items = [];
      const parentIds = new Set();

      parents.forEach((parent, pi) => {
        if (!cfg.includeSingle && parent.variants.length < 2 && !family) return;
        parent.variants.forEach((v) => {
          if (!v || !v.id || seen.has(v.id)) return;
          if (v.val === "Default Title" || v.vt === "Default Title") return;
          if (cfg.availableOnly && !v.avail) return;
          if (cfg.requireImage && !v.img) return;
          if (family && !(Array.isArray(v.fams) && v.fams.includes(family))) return;
          seen.add(v.id);
          items.push({ v, p: parent.product, pi, card: parent.card });
          parentIds.add(pi);
        });
      });

      /* Ordenação (padrão: ordem da grade + ordem do cadastro) */
      if (cfg.sort === "price_asc") items.sort((a, b) => (a.v.prc || 0) - (b.v.prc || 0));
      else if (cfg.sort === "price_desc") items.sort((a, b) => (b.v.prc || 0) - (a.v.prc || 0));
      else if (cfg.sort === "color_asc") {
        items.sort((a, b) => String(a.v.val || "").localeCompare(String(b.v.val || ""), "pt"));
      }

      const omitted = Math.max(0, items.length - cfg.maxVariants);
      return {
        items: items.slice(0, cfg.maxVariants),
        parentCount: parentIds.size,
        family,
        omitted,
      };
    };

    /* ── Renderização de um card ── */
    const renderItem = (item, position) => {
      const node = cardTpl.content.cloneNode(true);
      const li = node.querySelector("li");
      const { v, p } = item;
      const href = variantUrl(p.u, v.id);
      li.dataset.edgVxParent = String(item.pi);
      li.dataset.edgVxVariant = String(v.id);
      li.dataset.edgVxPosition = String(position);

      const img = node.querySelector("[data-edg-vx-img]");
      if (img && v.img) {
        const widths = WIDTHS.filter((w) => !v.w || w <= v.w);
        if (widths.length) {
          img.setAttribute("srcset", widths.map((w) => `${resized(v.img, w)} ${w}w`).join(", "));
        }
        img.setAttribute("src", resized(v.img, Math.min(v.w || 540, 540)));
        if (cfg.sizes) img.setAttribute("sizes", cfg.sizes);
        if (v.w) img.setAttribute("width", String(Math.min(v.w, 540)));
        img.setAttribute("alt", v.val ? `${p.t} — ${v.val}` : p.t);
      } else if (img) {
        img.remove();
      }

      node.querySelectorAll("[data-edg-vx-link]").forEach((a) => a.setAttribute("href", href));

      const title = node.querySelector("[data-edg-vx-title]");
      if (title) {
        title.textContent = p.t;
        if (v.val) title.setAttribute("aria-label", cfg.text.linkLabel.replace("{title}", p.t).replace("{color}", v.val));
      }

      const vendor = node.querySelector("[data-edg-vx-vendor]");
      if (vendor) {
        if (cfg.show.vendor && p.vd) {
          vendor.hidden = false;
          vendor.querySelector("span").textContent = p.vd;
        } else {
          vendor.remove();
        }
      }

      /* Nome da cor + demais opções da combinação (ex.: "Rosa · Canudo") */
      const colorLine = node.querySelector("[data-edg-vx-colorline]");
      if (colorLine) {
        let label = v.val || "";
        if (v.vt && v.vt.indexOf(" / ") > -1) {
          const extras = v.vt.split(" / ").filter((part) => part !== v.val);
          if (extras.length) label += (label ? " · " : "") + extras.join(" · ");
        }
        if (cfg.show.colorName && label) {
          colorLine.hidden = false;
          colorLine.querySelector("[data-edg-vx-colorname]").textContent = label;
          const dot = colorLine.querySelector("[data-edg-vx-dot]");
          if (dot) {
            if (cfg.show.dot && v.img) {
              dot.hidden = false;
              dot.style.setProperty("--swatch-background-image", `url(${resized(v.img, 72)})`);
            } else {
              dot.remove();
            }
          }
        } else {
          colorLine.remove();
        }
      }

      const price = node.querySelector("[data-edg-vx-price]");
      if (price) {
        if (cfg.show.price) {
          price.hidden = false;
          price.querySelector(".price__regular").textContent = v.price;
          if (cfg.show.compare && v.cprice) {
            price.classList.add("price--on-sale");
            const sale = document.createElement("span");
            sale.className = "price__sale inline-flex items-center h-auto relative";
            sale.textContent = v.cprice;
            price.appendChild(sale);
          }
        } else {
          price.remove();
        }
      }

      const badges = node.querySelector("[data-edg-vx-badges]");
      if (badges) {
        let badge = null;
        if (!v.avail) {
          badge = { cls: "badge--soldout", text: cfg.text.soldOut };
        } else if (cfg.show.compare && v.cprc && v.prc && v.cprc > v.prc) {
          badge = { cls: "badge--onsale", text: `-${Math.round((1 - v.prc / v.cprc) * 100)}%` };
        }
        if (cfg.show.badge && badge && badge.text) {
          badges.hidden = false;
          const span = document.createElement("span");
          span.className = `badge ${badge.cls} flex items-center gap-1d5 font-medium leading-none rounded-full`;
          span.textContent = badge.text;
          badges.appendChild(span);
        } else {
          badges.remove();
        }
      }

      /* Avaliação: clona a do card pai (mesmo markup/posição do tema) */
      if (cfg.show.rating && item.card) {
        const rating = item.card.querySelector(".product-card__rating");
        const media = node.querySelector(".product-card__media");
        if (rating && media) media.appendChild(rating.cloneNode(true));
      }

      return node;
    };

    /* ── Visibilidade: filtro por modelo + "Ver mais" em lotes ── */
    const updateVisibility = () => {
      const lis = Array.from(list.children);
      const pool = state.filter === null ? lis : lis.filter((li) => li.dataset.edgVxParent === state.filter);
      let visible = 0;
      lis.forEach((li) => {
        const inPool = pool.indexOf(li);
        const show = inPool > -1 && inPool < state.shown;
        li.hidden = !show;
        if (show) visible += 1;
      });

      if (counter) {
        counter.textContent = cfg.text.counter
          .replace("{shown}", String(visible))
          .replace("{count}", String(pool.length));
        counter.hidden = pool.length === 0;
      }
      if (moreBtn) {
        const remaining = pool.length - visible;
        moreBtn.hidden = remaining <= 0;
        if (moreLabel) {
          moreLabel.textContent = `${cfg.text.loadMore} (+${Math.min(cfg.step, Math.max(remaining, 0))})`;
        }
      }
      if (allShown) {
        allShown.hidden = !(cfg.text.allShown && pool.length > cfg.initial && visible >= pool.length);
        if (!allShown.hidden) {
          allShown.textContent = cfg.text.allShown.replace("{count}", String(pool.length));
        }
      }
    };

    const renderPills = () => {
      if (!pillsWrap || !pillsList || !pillTpl) return;
      pillsList.innerHTML = "";
      const models = [];
      const seen = new Set();
      state.items.forEach((item) => {
        if (seen.has(item.pi)) return;
        seen.add(item.pi);
        models.push({ pi: item.pi, title: item.p.t });
      });
      if (!cfg.modelFilters || models.length < 2) {
        pillsWrap.hidden = true;
        return;
      }
      pillsWrap.hidden = false;
      const addPill = (label, value, pressed) => {
        const node = pillTpl.content.cloneNode(true);
        const btn = node.querySelector("button");
        btn.textContent = label;
        btn.dataset.edgVxFilter = value;
        btn.setAttribute("aria-pressed", pressed ? "true" : "false");
        pillsList.appendChild(node);
      };
      addPill(cfg.text.filterAll, "", state.filter === null);
      models.forEach((m) => addPill(m.title, String(m.pi), state.filter === String(m.pi)));
    };

    /* ── Build completo (idempotente; assinatura evita re-render inútil) ── */
    const build = () => {
      const result = computeItems();
      const sig = `${result.family || ""}|${result.items.map((i) => i.v.id).join(",")}`;
      if (sig === state.sig) return;
      state.sig = sig;
      state.items = result.items;
      state.filter = null;
      state.shown = cfg.initial;

      const ok =
        result.items.length >= Math.max(cfg.minVariants, 1) &&
        result.parentCount >= cfg.minParents &&
        result.parentCount <= cfg.maxParents;

      list.innerHTML = "";
      if (!ok) {
        root.hidden = true;
        return;
      }

      const frag = document.createDocumentFragment();
      result.items.forEach((item, i) => frag.appendChild(renderItem(item, i + 1)));
      list.appendChild(frag);
      renderPills();
      updateVisibility();
      root.hidden = false;

      if (!state.viewed) {
        state.viewed = true;
        track("variant_explorer_view", {
          source: cfg.source,
          search_term: cfg.searchTerm || null,
          collection_handle: cfg.collectionHandle || null,
          color_family: result.family || null,
          total_variants: result.items.length,
          omitted: result.omitted,
        });
      }
    };

    /* ── Eventos (delegação — sem listeners por card) ── */
    root.addEventListener("click", (event) => {
      const pill = event.target.closest("[data-edg-vx-filter]");
      if (pill) {
        state.filter = pill.dataset.edgVxFilter === "" ? null : pill.dataset.edgVxFilter;
        state.shown = cfg.initial;
        pillsList.querySelectorAll("[data-edg-vx-filter]").forEach((btn) => {
          btn.setAttribute("aria-pressed", btn === pill ? "true" : "false");
        });
        updateVisibility();
        track("variant_explorer_filter_click", { source: cfg.source, filter: pill.textContent });
        return;
      }
      if (event.target.closest("[data-edg-vx-more]")) {
        state.shown += cfg.step;
        updateVisibility();
        track("variant_explorer_load_more", { source: cfg.source, shown: state.shown });
        return;
      }
      const link = event.target.closest("[data-edg-vx-link]");
      if (link) {
        const li = link.closest("li");
        track("variant_explorer_item_click", {
          source: cfg.source,
          variant_id: li ? li.dataset.edgVxVariant : null,
          position: li ? Number(li.dataset.edgVxPosition) : null,
          color_family: activeFamily() || null,
        });
      }
    });

    /* ── Sincronia com a grade (AJAX de filtros/ordenação/paginação) ── */
    let queued = false;
    const scheduleBuild = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        build();
      });
    };

    document.addEventListener("collection:reloaded", scheduleBuild);
    const grid = document.getElementById(GRID_ID);
    if (grid) {
      new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.addedNodes && mutation.addedNodes.length) {
            scheduleBuild();
            return;
          }
        }
      }).observe(grid, { childList: true, subtree: true });
    }
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) scheduleBuild();
    });

    build();
  };

  const initAll = () => {
    document.querySelectorAll("[data-edg-vx]").forEach(setup);
  };

  /* Este asset roda com defer ANTES do módulo inline edg-family-cards
     (fim do body), que exporta window.__edgActiveFamily__. DOMContentLoaded
     só dispara depois de todos os defer/module scripts → inicializar lá.
     "complete" = injeção tardia (editor); setup é idempotente. */
  if (document.readyState === "complete") {
    initAll();
  } else {
    document.addEventListener("DOMContentLoaded", initAll);
    window.addEventListener("load", initAll);
  }

  /* Editor de temas: re-inicializa quando a seção é recarregada */
  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target && event.target.querySelector && event.target.querySelector("[data-edg-vx]");
    if (root) setup(root);
  });
})();
